export const NetNewFilterIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_982_11558)">
        <path
          d="M9.87078 1.69985C10.3656 1.41255 10.9768 1.41255 11.4716 1.69984L16.9969 4.90765C17.4873 5.19238 17.7891 5.71614 17.7891 6.28267V12.7173C17.7891 13.2839 17.4873 13.8076 16.9969 14.0923L11.4716 17.3002C10.9768 17.5874 10.3656 17.5874 9.87078 17.3002L4.34554 14.0923C3.85511 13.8076 3.55335 13.2839 3.55335 12.7173V12.1634H5.54411V11.3113H2.30202V10.4593H6.31183V12.0419L10.6712 14.5839L15.0306 12.0419V6.95806L10.6712 4.41612L6.31183 6.95806V9.60723H1.67635V8.75518H5.54411V7.90313H2.64329V7.05108H3.55335V6.28267C3.55335 5.71614 3.85511 5.19238 4.34554 4.90765L9.87078 1.69985Z"
          fill="#78C51C"
        />
        <path
          d="M0.481898 7.90313H1.33508V8.75518H0.481898V7.90313Z"
          fill="#78C51C"
        />
        <path
          d="M0.993807 9.60723H0.140625V10.4593H0.993807V9.60723Z"
          fill="#78C51C"
        />
        <path
          d="M1.22132 11.3113H2.0745V12.1634H1.22132V11.3113Z"
          fill="#78C51C"
        />
      </g>
      <defs>
        <clipPath id="clip0_982_11558">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
